const blocks = document.querySelectorAll('.block-stat');

const inView = (block) => {
	const counters = block.querySelectorAll('.block-stat__counter');

	if (counters.length > 0) {
		counters.forEach((counter) => {
			const originalText = counter.textContent.trim();
			const target = Number(originalText);
			const hasDecimal = originalText.includes('.');
			const decimals = hasDecimal ? originalText.split('.')[1].length : 0;
			const integerLength = hasDecimal
				? originalText.split('.')[0].length
				: originalText.length;

			const duration = 1500;
			const start = performance.now();

			const format = (value) => {
				if (hasDecimal) {
					const fixed = value.toFixed(decimals);
					const [intPart, decPart] = fixed.split('.');
					return `${intPart.padStart(integerLength, '0')}.${decPart}`;
				}

				return Math.floor(value)
					.toString()
					.padStart(integerLength, '0');
			};

			counter.textContent = hasDecimal
				? `${'0'.repeat(integerLength)}.${'0'.repeat(decimals)}`
				: '0'.repeat(integerLength);

			block.classList.add('block-stat--visible');

			const tick = (now) => {
				const progress = Math.min((now - start) / duration, 1);
				counter.textContent = format(progress * target);

				if (progress < 1) {
					requestAnimationFrame(tick);
				}
			};

			requestAnimationFrame(tick);
		});
	} else {
		block.classList.add('block-stat--visible');
	}
};

blocks.forEach((block) => {
	const observer = new IntersectionObserver(
		(entries, obs) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					inView(block);
					obs.unobserve(block);
				}
			});
		},
		{
			root: null,
			rootMargin: '0px 0px -20% 0px',
			threshold: [0],
		}
	);

	observer.observe(block);
});
